<template>
  <div class="view pa24">
    <el-button
      type="primary"
      @click="
        centerDialogVisible = true;
        bEdit = false;
      "
      >{{ $t('marketing', 'addCoupon') }}</el-button
    >
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
          width="50"
          type="index"
          align="center"
          :label="getSerialNumberText()"
          show-overflow-tooltip
        />
        <el-table-column prop="name" align="center" :label="$t('marketing', 'couponName')" show-overflow-tooltip/>
        <el-table-column prop="goodsTypeName" align="center" :label="$t('marketing', 'usageScope')" show-overflow-tooltip/>
        <el-table-column prop="grantModeText" align="center" :label="$t('marketing', 'distributionMethod')" show-overflow-tooltip/>
        <el-table-column
          prop="grantObjectText"
          show-overflow-tooltip
          align="center"
          :label="$t('marketing', 'distributionTarget')"
        />
        <el-table-column
          prop="receiveNum"
          show-overflow-tooltip
          align="center"
          :label="$t('marketing', 'receiveQuantity')"
        >
          <template slot-scope="scope">
            <span style="color: #51cdcb">{{ scope.row.receiveNum }}{{ $t('marketing', 'pieces') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="couponTypeText"
          align="center"
          :label="$t('marketing', 'couponType')"
        />
        <el-table-column prop="address" align="center" show-overflow-tooltip :label="$t('marketing', 'couponDiscount')">
          <template slot-scope="scope">
            <span style="color: #fd634e" v-if="scope.row.couponType == 1"
              >{{ scope.row.couponFaceValue }}元</span
            >
            <span style="color: #fd634e" v-if="scope.row.couponType == 2"
              >{{ scope.row.couponDiscount }}折</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="minAmount" align="center" show-overflow-tooltip :label="$t('marketing', 'minimumSpend')">
          <template slot-scope="scope">
            <span>{{ scope.row.minAmount }}元</span>
          </template>
        </el-table-column>
        <el-table-column prop="couponNum" align="center" show-overflow-tooltip :label="$t('marketing', 'issueRemaining')">
          <template slot-scope="scope">
            <span
              style="color:#51CBCD"
              >{{
                scope.row.couponNum === 0
                  ? $t('marketing', 'unlimited')
                  : scope.row.couponNum + "/"
              }}</span>
              <span>{{ scope.row.couponNum - scope.row.receiveNum }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip :label="$t('marketing', 'distributionDate')" width="200">
          <template slot-scope="scope">
            <span
              >{{ scope.row.grantStartTime }}到{{
                scope.row.grantEndTime
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('marketing', 'validDate')" show-overflow-tooltip width="200">
          <template slot-scope="scope">
            <span
              >{{ scope.row.effectiveStartTime }}到{{
                scope.row.effectiveEndTime
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="pubState"
          align="center"
          :label="$t('marketing', 'publishStatus')"
          width="140"
        >
          <template slot-scope="scope">
            <el-switch
              @change="(e) => pubStateChange(e, scope.row)"
              :value="scope.row.pubState == 2 ? true : false"
              :active-text="getEnableText()"
              :inactive-text="getDisableText()"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" width="200" :label="$t('common', 'edit')">
          <template slot-scope="scope">
            <el-button class="mr10" type="text" @click="detail(scope.row.couponId)"
              >{{ getReceiveRecordText() }}</el-button
            >
            <el-button class="mr10" type="text" @click="edit(scope.row)"
              >{{ $t('common', 'edit') }}</el-button
            >
            <customPopconfirm
              :confirm-button-text="$t('common', 'confirm')"
              :cancel-button-text="$t('common', 'cancel')"
              @confirm="del(scope.row.couponId)"
              icon="el-icon-info"
              icon-color="red"
              :title="getDeleteConfirmText()" >
              <el-button slot="reference" style="color: #fd634e" type="text"
                >{{ $t('common', 'delete') }}</el-button
              >
            </customPopconfirm>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog
      :title="$t('marketing', 'addCoupon')"
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="40%"
    >
      <addCoupon
        :bEdit="bEdit"
        @submitForm="submitForm"
        @onConfirmEdit="onConfirmEdit"
        ref="addCoupon"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            centerDialogVisible = false;
            bEdit = false;
          "
          >{{ $t('common', 'cancel') }}</el-button
        >
        <el-button type="primary" @click="determine">{{ $t('common', 'confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import { crmPcPageList, updState, add, del, upd } from "@/api/coupon";
import addCoupon from "./addCoupon";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  name: "couponList",
  mixins: [i18nMixin],
  components: {
    commonTable,
    addCoupon,
    customPopconfirm
  },
  data() {
    return {
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      centerDialogVisible: false,
      bEdit: false, //编辑
      couponId: "", //编辑时需要传的id
      companyId: "", //编辑时需要传的id
    };
  },
  created() {
    this.crmPcPageList();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    /**@method  优惠券列表*/
    async crmPcPageList() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      };
      try {
        this.loading = true;
        const result = await crmPcPageList(data);
        this.loading = false;
        const { total, list } = result?.data;
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    
    // 多语言方法
    getCurrentLanguage() {
      let currentLanguage = this.$store.state.currentLanguage;
      if (!currentLanguage) {
        currentLanguage = localStorage.getItem('language') || 'zh-TW';
      }
      return currentLanguage;
    },
    
    getSerialNumberText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '序号',
        'zh-TW': '序號',
        'en': 'Serial Number'
      };
      return textMap[currentLanguage] || '序号';
    },
    
    getReceiveRecordText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '领取记录',
        'zh-TW': '領取記錄',
        'en': 'Receive Record'
      };
      return textMap[currentLanguage] || '领取记录';
    },
    
    getDeleteConfirmText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '确认要删除这个优惠券吗？',
        'zh-TW': '確認要刪除這個優惠券嗎？',
        'en': 'Confirm to delete this coupon?'
      };
      return textMap[currentLanguage] || '确认要删除这个优惠券吗？';
    },
    
    getEnableText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '启用',
        'zh-TW': '啟用',
        'en': 'Enable'
      };
      return textMap[currentLanguage] || '启用';
    },
    
    getDisableText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '禁用',
        'zh-TW': '禁用',
        'en': 'Disable'
      };
      return textMap[currentLanguage] || '禁用';
    },
    /**@method 发布状态 */
    async pubStateChange(e, { couponId }) {
      let data = {
        couponId,
        pubState: e ? 2 : 1,
      };
      await updState(data);
      await this.crmPcPageList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.crmPcPageList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.crmPcPageList();
    },
    determine() {
      this.$refs.addCoupon.submitForm();
    },
    /**
     * @method 发布优惠券
     * @param {Object} val - 表单值
     */
    async submitForm(val) {
      delete val.rangeType;
      let data = {
        ...val,
        goodstypeId: val.goodstypeId == "" ? 0 : val.goodstypeId,
        goodstypeIds: 0,
        pubState: val.pubState ? 2 : 1,
        grantStartTime: val.grantTime[0],
        grantEndTime: val.grantTime[1],
        effectiveStartTime: val.effectiveDate[0],
        effectiveEndTime: val.effectiveDate[1],
      };
      try {
        await add(data, { showLoading: true });
        this.centerDialogVisible = false;
        await this.crmPcPageList();
      } catch (error) {
        console.log(error);
         this.$message({
          message: error.message || "失败",
          type: "warning",
        });
      }
    },
    /**
     * @method 删除优惠券
     * @param {String} val - id
     */
    async del(val) {
      try {
        await del({ couponId: val });
        await this.crmPcPageList();
      } catch (error) {
        console.log(error);
        this.$message({
          message: error.message || "请选择需求",
          type: "warning",
        });
      }
    },
    /**
     * @method 领取记录
     * @param {String} val - 优惠券id
     */
    detail(id){
      this.$router.push('detailCoupon?id='+ id)
    },


    /**@method 编辑
     * @param {Object} val - 当前点击行的值
     */
    edit(val) {
      this.centerDialogVisible = true;
      this.bEdit = true;
      console.log(val);
      const {
        name,
        minAmount,
        couponType,
        couponFaceValue,
        rangeType,
        grantStartTime,
        grantEndTime,
        effectiveStartTime,
        effectiveEndTime,
        grantMode,
        couponNum,
        maxUser,
        pubState,
        couponId,
        companyId,
        goodstypeId,
        couponDiscount,
      } = val;
      this.couponId = couponId;
      this.companyId = companyId;
      let data = {
        name,
        minAmount,
        couponType: String(couponType),
        couponFaceValue,
        rangeType:
          goodstypeId && goodstypeId != 0 && goodstypeId != "" ? "2" : "1",
        grantTime: [grantStartTime, grantEndTime],
        effectiveDate: [effectiveStartTime, effectiveEndTime],
        grantMode: String(grantMode),
        couponNum,
        maxUser,
        pubState: pubState == 1 ? false : true,
        goodstypeId: val.goodstypeId ? val.goodstypeId : 0,
        couponDiscount,
      };
      this.$nextTick(() => {
        this.$refs.addCoupon.ruleForm = data;
      });
    },
    /**@method 确定编辑 */
    async onConfirmEdit(val) {
      delete val.rangeType;
      let data = {
        ...val,
        couponId: this.couponId,
        companyId: this.companyId,
        goodstypeId: val.goodstypeId ? val.goodstypeId : 0,
        goodstypeIds: 0,
        pubState: val.pubState ? 2 : 1,
        grantStartTime: val.grantTime[0],
        grantEndTime: val.grantTime[1],
        effectiveStartTime: val.effectiveDate[0],
        effectiveEndTime: val.effectiveDate[1],
      };
      console.log(data);
      try {
        await upd(data, { showLoading: true });
        this.centerDialogVisible = false;
        this.bEdit = false;
        await this.crmPcPageList();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>